const ENTITY_TYPE = 'company';

const DEFAULT_FINANCIAL_LINE_ITEMS = {
  incomeStatement: [
    {
      label: 'Sales',
      disabled: false,
      type: 'incomeStatement'
    },
    {
      label: 'Cost of Goods Sold',
      disabled: false,
      type: 'incomeStatement'
    },
    {
      label: 'General and Administrative Expenses',
      disabled: false,
      type: 'incomeStatement'
    },
    {
      label: 'Other Income (Expenses)',
      disabled: false,
      type: 'incomeStatement'
    },
    {
      label: 'Provision for Income Tax',
      disabled: false,
      type: 'incomeStatement'
    },
    {
      label: 'Total Comprehensive Income',
      disabled: true,
      type: 'incomeStatement'
    }
  ],
  currentAssets: [
    {
      label: 'Cash',
      disabled: false,
      type: 'currentAssets'
    },
    {
      label: 'Receivables',
      disabled: false,
      type: 'currentAssets'
    },
    {
      label: 'Inventories',
      disabled: false,
      type: 'currentAssets'
    },
    {
      label: 'Prepayments and other current assets',
      disabled: false,
      type: 'currentAssets'
    },
    {
      label: 'Total current assets',
      disabled: true,
      type: 'currentAssets'
    }
  ],
  nonCurrentAssets: [
    {
      label: 'Property and equipment',
      disabled: false,
      type: 'nonCurrentAssets'
    },
    {
      label: 'Investment property',
      disabled: false,
      type: 'nonCurrentAssets'
    },
    {
      label: 'Trademark',
      disabled: false,
      type: 'nonCurrentAssets'
    },
    {
      label: 'Deferred tax assets',
      disabled: false,
      type: 'nonCurrentAssets'
    },
    {
      label: 'Security deposits',
      disabled: false,
      type: 'nonCurrentAssets'
    },
    {
      label: 'Other noncurrent assets',
      disabled: false,
      type: 'nonCurrentAssets'
    },
    {
      label: 'Total non-current assets',
      disabled: true,
      type: 'nonCurrentAssets'
    }
  ],
  currentLiabilities: [
    {
      label: 'Notes payable (current)',
      disabled: false,
      type: 'currentLiabilities'
    },
    {
      label: 'Accounts payable and other current liabilities',
      disabled: false,
      type: 'currentLiabilities'
    },
    {
      label: 'Total current liabilities',
      disabled: true,
      type: 'currentLiabilities'
    },
  ],
  nonCurrentLiabilities: [
    {
      label: 'Notes payable (non-current)',
      disabled: false,
      type: 'nonCurrentLiabilities'
    },
    {
      label: 'Deposits from tenants',
      disabled: false,
      type: 'nonCurrentLiabilities'
    },
    {
      label: 'Total non-current liabilities',
      disabled: true,
      type: 'nonCurrentLiabilities'
    },
  ],
  equity: [
    {
      label: 'Capital stock',
      disabled: false,
      type: 'equity'
    },
    {
      label: 'Retained earnings',
      disabled: false,
      type: 'equity'
    },
    {
      label: 'Other comprehensive income / (loss)',
      disabled: false,
      type: 'equity'
    },
    {
      label: 'Total equity',
      disabled: true,
      type: 'equity'
    }
  ]
}

const FINANCIAL_STATEMENT_TYPES = [
  { key: 'incomeStatement', text: 'Income Statement', value: 'incomeStatement' },
  { key: 'currentAssets', text: 'Current Assets', value: 'currentAssets' },
  { key: 'nonCurrentAssets', text: 'Non Current Assets', value: 'nonCurrentAssets' },
  { key: 'currentLiabilities', text: 'Current Liabilities', value: 'currentLiabilities' },
  { key: 'nonCurrentLiabilities', text: 'Non Current Liabilities', value: 'nonCurrentLiabilities' },
  { key: 'equity', text: 'Equity', value: 'equity' }
];

const FINANCIAL_MAGNITUDE_OPTIONS = [
  { key: '1', text: '1', value: 1 },
  { key: '1000', text: '1000', value: 1000 },
  { key: '1000000', text: '1000000', value: 1000000 }
]

const FINANCIAL_CURRENCIES_OPTIONS = [
  { key: 160, text: "US Dollar", value: "USD" },
  { key: 55, text: "British Pound", value: "GBP" },
  { key: 50, text: "Euro", value: "EUR" },
  { key: 7, text: "Argentine Peso", value: "ARS" },
  { key: 79, text: "Japanese Yen", value: "JPY" },
  { key: 137, text: "Swedish Krona", value: "SEK" },
  { key: 506, text: "New Azerbaijan Manat", value: "AZN" },
  { key: 19, text: "Brunei Dollar", value: "BND" },
  { key: 505, text: "Romanian Leu", value: "RON" },
  { key: 166, text: "Western Samoa Tala", value: "WST" },
  { key: 4, text: "Armenia Dram", value: "AMD" },
  { key: 2, text: "Afghanistan Afghani", value: "AFN" },
  { key: 140, text: "Slovenian Tolar", value: "SIT" },
  { key: 530, text: "Belarusian Ruble", value: "BYN" },
  { key: 40, text: "German Deutschmark", value: "DEM" },
  { key: 46, text: "Estonian Kroon", value: "EEK" },
  { key: 69, text: "Indonesian Rupiah", value: "IDR" },
  { key: 20, text: "Bolivian Boliviano", value: "BOB" },
  { key: 159, text: "Uganda Shilling", value: "UGX" },
  { key: 162, text: "Uzbekistan Sum", value: "UZS" },
  { key: 53, text: "Falkland Island Pound", value: "FKP" },
  { key: 118, text: "Nepalese Rupee", value: "NPR" },
  { key: 142, text: "Sierra Leone Leone", value: "SLL" },
  { key: 17, text: "Burundi Franc", value: "BIF" },
  { key: 527, text: "US Cent", value: "USX" },
  { key: 85, text: "South Korean Won", value: "KRW" },
  { key: 132, text: "Rwanda Franc", value: "RWF" },
  { key: 71, text: "Israeli Shekel", value: "ILS" },
  { key: 22, text: "Bahamas Dollar", value: "BSD" },
  { key: 33, text: "Colombian Peso", value: "COP" },
  { key: 13, text: "Bangladesh Taka", value: "BDT" },
  { key: 16, text: "Bahraini Dinar", value: "BHD" },
  { key: 507, text: "Mozambique Metical", value: "MZN" },
  { key: 509, text: "Venezuelan Bolivar Fuerte", value: "VEF" },
  { key: 11, text: "Azerbaijan Manet", value: "AZM" },
  { key: 90, text: "Lebanese Pound", value: "LBP" },
  { key: 5, text: "Netherlands Antilles Guilder", value: "ANG" },
  { key: 18, text: "Bermuda Dollar", value: "BMD" },
  { key: 97, text: "Libyan Dinar", value: "LYD" },
  { key: 26, text: "Belize Dollar", value: "BZD" },
  { key: 92, text: "Liberian Dollar", value: "LRD" },
  { key: 171, text: "CFP Franc", value: "XPF" },
  { key: 164, text: "Vietnamese Dong", value: "VND" },
  { key: 9, text: "Australian Dollar", value: "AUD" },
  { key: 100, text: "Malagasy Franc", value: "MGF" },
  { key: 24, text: "Botswana Pula", value: "BWP" },
  { key: 115, text: "Nicaragua Cordoba Oro", value: "NIO" },
  { key: 520, text: "Chinese Offshore Yuan", value: "CNH" },
  { key: 521, text: "Zambian New Kwacha", value: "ZMW" },
  { key: 102, text: "Myanmar (Burma) Kyat", value: "MMK" },
  { key: 184, text: "Nafka", value: "ERN" },
  { key: 111, text: "Malaysian Ringgit", value: "MYR" },
  { key: 8, text: "Austrian Schilling", value: "ATS" },
  { key: 139, text: "St Helena Pound", value: "SHP" },
  { key: 60, text: "Guinea Franc", value: "GNF" },
  { key: 27, text: "Canadian Dollar", value: "CAD" },
  { key: 44, text: "Algerian Dinar", value: "DZD" },
  { key: 149, text: "Thai Baht", value: "THB" },
  { key: 99, text: "Moldovan Leu", value: "MDL" },
  { key: 152, text: "Tunisian Dinar", value: "TND" },
  { key: 120, text: "Oman Rial", value: "OMR" },
  { key: 74, text: "Iran Rial", value: "IRR" },
  { key: 62, text: "Guatemala Quetzal", value: "GTQ" },
  { key: 76, text: "Italian Lire", value: "ITL" },
  { key: 529, text: "Israeli Agorot", value: "ILA" },
  { key: 39, text: "East German Ostmark", value: "DDM" },
  { key: 128, text: "Paraguay Guarani", value: "PYG" },
  { key: 125, text: "Pakistan Rupee", value: "PKR" },
  { key: 87, text: "Cayman Islands Dollar", value: "KYD" },
  { key: 167, text: "East Caribbean Dollar", value: "XCD" },
  { key: 528, text: "South African Cent", value: "ZAC" },
  { key: 95, text: "Luxembourg Franc", value: "LUF" },
  { key: 511, text: "Sudanese Pound", value: "SDG" },
  { key: 107, text: "Mauritian Rupee", value: "MUR" },
  { key: 119, text: "New Zealand Dollar", value: "NZD" },
  { key: 131, text: "Russian Rouble", value: "RUB" },
  { key: 123, text: "Papua New Guinea Kina", value: "PGK" },
  { key: 77, text: "Jamaican Dollar", value: "JMD" },
  { key: 156, text: "Taiwan Dollar", value: "TWD" },
  { key: 117, text: "Norwegian Krone", value: "NOK" },
  { key: 88, text: "Kazakhstan Tenge", value: "KZT" },
  { key: 145, text: "Sao Tome & Principe Dobra", value: "STD" },
  { key: 174, text: "South African Rand", value: "ZAR" },
  { key: 519, text: "New Zimbabwe Dollar", value: "ZWL" },
  { key: 176, text: "Zimbabwe Dollar", value: "ZWD" },
  { key: 147, text: "Syrian Pound", value: "SYP" },
  { key: 52, text: "Fiji Dollar", value: "FJD" },
  { key: 173, text: "Yugoslav Dinar", value: "YUM" },
  { key: 504, text: "Surinam Dollar", value: "SRD" },
  { key: 32, text: "Chinese Renminbi (Yuan)", value: "CNY" },
  { key: 503, text: "Serbian Dinar", value: "RSD" },
  { key: 91, text: "Sri Lanka Rupee", value: "LKR" },
  { key: 523, text: "Mexican Unidad de Inversion", value: "MXV" },
  { key: 114, text: "Nigerian Naira", value: "NGN" },
  { key: 78, text: "Jordanian Dinar", value: "JOD" },
  { key: 68, text: "Hungarian Forint", value: "HUF" },
  { key: 30, text: "Chilean Unidades De Fomento", value: "CLF" },
  { key: 113, text: "Namibian Dollar", value: "NAD" },
  { key: 155, text: "Trinidad and Tobago Dollar", value: "TTD" },
  { key: 148, text: "Swaziland Lilangeni", value: "SZL" },
  { key: 72, text: "Indian Rupee", value: "INR" },
  { key: 47, text: "Egyptian Pound", value: "EGP" },
  { key: 116, text: "Netherlands Guilder", value: "NLG" },
  { key: 108, text: "Maldive Is Rufiyaa", value: "MVR" },
  { key: 172, text: "Yemeni Rial", value: "YER" },
  { key: 25, text: "Belarus Rouble", value: "BYR" },
  { key: 56, text: "Georgia Lari", value: "GEL" },
  { key: 31, text: "Chilean Peso", value: "CLP" },
  { key: 57, text: "Ghana Cedi", value: "GHC" },
  { key: 144, text: "Surinam Guilder", value: "SRG" },
  { key: 37, text: "Cyprus Pound", value: "CYP" },
  { key: 183, text: "CFA Franc BEAC", value: "XAF" },
  { key: 133, text: "Saudi Arabian Riyal", value: "SAR" },
  { key: 45, text: "Ecuador Sucre", value: "ECS" },
  { key: 81, text: "Kyrgyzstan Som", value: "KGS" },
  { key: 180, text: "Convertible Mark", value: "BAM" },
  { key: 61, text: "Greek Drachma", value: "GRD" },
  { key: 165, text: "Vanuatu Vatu", value: "VUV" },
  { key: 124, text: "Philippines Peso", value: "PHP" },
  { key: 65, text: "Honduras Lempira", value: "HNL" },
  { key: 105, text: "Mauritania Ouguiya", value: "MRO" },
  { key: 6, text: "Angola Kwanza", value: "AOA" },
  { key: 86, text: "Kuwait Dinar", value: "KWD" },
  { key: 510, text: "New Ghana Cedi", value: "GHS" },
  { key: 135, text: "Seychelles Rupee", value: "SCR" },
  { key: 83, text: "Comoros Franc", value: "KMF" },
  { key: 518, text: "Turkmenistan New Manet", value: "TMT" },
  { key: 70, text: "Irish Punt", value: "IEP" },
  { key: 141, text: "Slovakian Koruna", value: "SKK" },
  { key: 15, text: "Bulgarian Lev", value: "BGN" },
  { key: 101, text: "Macedonian Denar", value: "MKD" },
  { key: 3, text: "Albanian Lek", value: "ALL" },
  { key: 80, text: "Kenya Shilling", value: "KES" },
  { key: 138, text: "Singapore Dollar", value: "SGD" },
  { key: 94, text: "Lithuanian Litas", value: "LTL" },
  { key: 134, text: "Solomon Island Dollar", value: "SBD" },
  { key: 98, text: "Moroccan Dirham", value: "MAD" },
  { key: 175, text: "Zambian Kwacha", value: "ZMK" },
  { key: 185, text: "Somoni", value: "TJS" },
  { key: 48, text: "Spanish Peseta", value: "ESP" },
  { key: 54, text: "French Franc", value: "FRF" },
  { key: 12, text: "Barbados Dollar", value: "BBD" },
  { key: 59, text: "Gambia Dalasi", value: "GMD" },
  { key: 41, text: "Djibouti Franc", value: "DJF" },
  { key: 73, text: "Iraqi Dinar", value: "IQD" },
  { key: 84, text: "North Korean Won", value: "KPW" },
  { key: 34, text: "Costa Rica Colon", value: "CRC" },
  { key: 89, text: "Laos New Kip", value: "LAK" },
  { key: 58, text: "Gibraltar Pound", value: "GIP" },
  { key: 526, text: "British Pence", value: "GBX" },
  { key: 1, text: "United Arab Emirates Dirham", value: "AED" },
  { key: 29, text: "Swiss Franc", value: "CHF" },
  { key: 126, text: "Polish Zloty", value: "PLN" },
  { key: 153, text: "Tonga Pa'Anga", value: "TOP" },
  { key: 136, text: "Sudanese Dinar", value: "SDD" },
  { key: 23, text: "Bhutan Ngultrum", value: "BTN" },
  { key: 35, text: "Cuban Peso", value: "CUP" },
  { key: 158, text: "Ukraine Hryvna", value: "UAH" },
  { key: 112, text: "Old Mozambique Metical", value: "MZM" },
  { key: 104, text: "Macau Pataca", value: "MOP" },
  { key: 146, text: "El Salvador Colon", value: "SVC" },
  { key: 42, text: "Danish Krone", value: "DKK" },
  { key: 109, text: "Malawi Kwacha", value: "MWK" },
  { key: 168, text: "Special Drawing Rights", value: "XDR" },
  { key: 161, text: "Peso Uruguayo", value: "UYU" },
  { key: 36, text: "Cape Verde Escudo", value: "CVE" },
  { key: 127, text: "Portuguese Escudo", value: "PTE" },
  { key: 63, text: "Guyana Dollar", value: "GYD" },
  { key: 163, text: "Venezuelan Bolivar", value: "VEB" },
  { key: 121, text: "Panama Balboa", value: "PAB" },
  { key: 103, text: "Mongolian Tugrik", value: "MNT" },
  { key: 51, text: "Finnish Markka", value: "FIM" },
  { key: 130, text: "Romanian Leu (old)", value: "ROL" },
  { key: 157, text: "Tanzania Shilling", value: "TZS" },
  { key: 129, text: "Qatari Rial", value: "QAR" },
  { key: 143, text: "Somali Shilling", value: "SOS" },
  { key: 169, text: "European Currency Unit", value: "XEU" },
  { key: 154, text: "Old Turkish Lira", value: "TRL" },
  { key: 189, text: "Turkish Lira", value: "TRY" },
  { key: 93, text: "Lesotho Loti", value: "LSL" },
  { key: 96, text: "Latvian Lats", value: "LVL" },
  { key: 10, text: "Aruban Guilder", value: "AWG" },
  { key: 64, text: "Hong Kong Dollar", value: "HKD" },
  { key: 67, text: "Haiti Gourde", value: "HTG" },
  { key: 21, text: "Brazilian Real", value: "BRL" },
  { key: 43, text: "Dominican Rep Peso", value: "DOP" },
  { key: 14, text: "Belgian Franc", value: "BEF" },
  { key: 82, text: "Cambodian (Kampuchea) Riel", value: "KHR" },
  { key: 188, text: "Ariary", value: "MGA" },
  { key: 170, text: "CFA (BCEAO) Franc", value: "XOF" },
  { key: 122, text: "Peruvian Sol", value: "PEN" },
  { key: 38, text: "Czech Koruna", value: "CZK" },
  { key: 66, text: "Croatian Kuna", value: "HRK" },
  { key: 28, text: "Congo (Dem. Rep.) Franc", value: "CDF" },
  { key: 110, text: "Mexican Peso", value: "MXN" },
  { key: 75, text: "Icelandic Krona", value: "ISK" },
  { key: 106, text: "Maltese Pound", value: "MTL" },
  { key: 49, text: "Ethiopian Birr", value: "ETB" }
]

const FINANCIAL_YEARS_OPTIONS = [
  {key: '2020', text: '2020', value: '2020'},
  {key: '2019', text: '2019', value: '2019'},
  {key: '2018', text: '2018', value: '2018'},
  {key: '2017', text: '2017', value: '2017'},
  {key: '2016', text: '2016', value: '2016'},
  {key: '2015', text: '2015', value: '2015'},
  {key: '2014', text: '2014', value: '2014'},
  {key: '2013', text: '2013', value: '2013'}
];

const INDUSTRY_MAPPING = {
  "Energy Equipment and Services": "Energy",
  "Oil, Gas and Consumable Fuels": "Energy",
  "Chemicals": "Materials",
  "Construction Materials": "Materials",
  "Containers and Packaging": "Materials",
  "Metals and Mining": "Materials",
  "Paper and Forest Products": "Materials",
  "Aerospace and Defense": "Capital Goods",
  "Building Products": "Capital Goods",
  "Construction and Engineering": "Capital Goods",
  "Electrical Equipment": "Capital Goods",
  "Industrial Conglomerates": "Capital Goods",
  "Machinery": "Capital Goods",
  "Trading Companies and Distributors": "Capital Goods",
  "Commercial Services and Supplies": "Commercial & Professional Services",
  "Professional Services": "Commercial & Professional Services",
  "Air Freight and Logistics": "Transportation",
  "Airlines": "Transportation",
  "Marine": "Transportation",
  "Road and Rail": "Transportation",
  "Transportation Infrastructure": "Transportation",
  "Auto Components": "Automobiles & Components",
  "Automobiles": "Automobiles & Components",
  "Household Durables": "Consumer Services",
  "Leisure Products": "Consumer Services",
  "Textiles, Apparel and Luxury Goods": "Consumer Services",
  "Hotels, Restaurants and Leisure": "Consumer Services",
  "Diversified Consumer Services": "Consumer Services",
  "Media": "Media and Entertainment",
  "Distributors": "Retailing",
  "Internet and Catalog Retail": "Retailing",
  "Multiline Retail": "Retailing",
  "Specialty Retail": "Retailing",
  "Food and Staples Retailing": "Food and Staples Retailing",
  "Beverages": "Food, Beverage and Tobacco",
  "Food Products": "Food, Beverage and Tobacco",
  "Tobacco": "Food, Beverage and Tobacco",
  "Household Products": "Household and Personal Products",
  "Personal Products": "Household and Personal Products",
  "Healthcare Equipment and Supplies": "Health Care Equipment and Services",
  "Healthcare Providers and Services": "Health Care Equipment and Services",
  "Health Care Technology": "Health Care Equipment and Services",
  "Biotechnology": "Pharmaceuticals, Biotechnology and Life Sciences",
  "Pharmaceuticals": "Pharmaceuticals, Biotechnology and Life Sciences",
  "Life Sciences Tools and Services": "Pharmaceuticals, Biotechnology and Life Sciences",
  "Banks": "Banks",
  "Thrifts and Mortgage Finance": "Banks",
  "Diversified Financial Services": "Diversified Financials",
  "Consumer Finance": "Diversified Financials",
  "Capital Markets": "Diversified Financials",
  "Insurance": "Insurance",
  "Real Estate Investment Trusts (REITs)": "Real Estate",
  "Real Estate Management and Development": "Real Estate",
  "Internet Software and Services": "Software and Services",
  "IT Services": "Software and Services",
  "Software": "Software and Services",
  "Communications Equipment": "Technology Hardware and Equipment",
  "Technology Hardware, Storage and Peripherals": "Technology Hardware and Equipment",
  "Electronic Equipment, Instruments and Components": "Technology Hardware and Equipment",
  "Semiconductors and Semiconductor Equipment": "Semiconductors and Semiconductor Equipment",
  "Diversified Telecommunication Services": "Telecommunication Services",
  "Wireless Telecommunication Services": "Telecommunication Services",
  "Electric Utilities": "Utilities",
  "Gas Utilities": "Utilities",
  "Multi-Utilities": "Utilities",
  "Water Utilities": "Utilities",
  "Independent Power and Renewable Electricity Producers": "Utilities"
}

const COMPANY_TYPE_OPTIONS = [
  {key: 'Private', text: 'Private', value: 'Private'},
  {key: 'Public', text: 'Public', value: 'Public'}
];

const COMPANY_STATUS_OPTIONS = [
  {key: 'Active', text: 'Active', value: 'Active'},
  {key: 'Inactive', text: 'Inactive', value: 'Inactive'},
  {key: 'NA', text: 'NA', value: 'NA'}
]


const COUNTRIES = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antarctica","Antigua & Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia-Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Colombia","Comoros","Republic of the Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Fiji","Finland","France","French Guiana","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Ivory Coast","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","North Korea","Norway","Oman","Pakistan","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Reunion","Romania","Russia","Rwanda","Saint Lucia","Saint Vincent & Grenadines","Samoa","San Marino","Saudi Arabia","Senegal","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","Spain","Sri Lanka","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Tajikistan","Taiwan","Tanzania","Thailand","Togo","Tonga","Trinidad & Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","British Virgin Islands","Yemen","Yugoslavia","Zambia","Zimbabwe","Channel Islands","Democratic Republic of the Congo","Eritrea","French Polynesia","Saint Kitts & Nevis","Turks & Caicos Islands","Serbia","Timor-Leste","Montenegro","Isle of Man","Palestinian Authority","Kosovo","Curaçao","Other","Guernsey","Offshore","Jersey","Niue"];



export {
  COUNTRIES,
  ENTITY_TYPE,
  DEFAULT_FINANCIAL_LINE_ITEMS,
  FINANCIAL_STATEMENT_TYPES,
  FINANCIAL_YEARS_OPTIONS,
  FINANCIAL_MAGNITUDE_OPTIONS,
  FINANCIAL_CURRENCIES_OPTIONS,
  INDUSTRY_MAPPING,
  COMPANY_STATUS_OPTIONS,
  COMPANY_TYPE_OPTIONS
}